import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTBusMapSelectorStudentRequest } from "./BTBusMapSelectorStudentRequest";
import { BTBusMapSelectorBusRequest } from "./BTBusMapSelectorBusRequest";
import { BTSendAlertRequest } from "./BTSendAlertRequest";
import { BusAlertToggleRequest } from "./BusAlertToggleRequest";
import { GeoFenceAlertToggleRequest } from "./GeoFenceAlertToggleRequest";
import { BTBusGetPersonPhotosRequest } from "./BTBusGetPersonPhotosRequest";

@Injectable()
export class DataService_BusTrackerMap {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMapPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapPreferenceSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusPositionSelectList(UserID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusPositionSelectList?UserID=" + UserID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentPositionSelectList(UserID) {
		var postResult$ = new Subject();
		var url = "BusTracker/StudentPositionSelectList?UserID=" + UserID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusMapSelectorBusModeSelectList(parms: BTBusMapSelectorBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapSelectorBusModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusMapSelectorStudentModeSelectList(parms: BTBusMapSelectorStudentRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapSelectorStudentModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusAlertTypeSelectList(ActiveOnly) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusAlertTypeSelectList?ActiveOnly=" + ActiveOnly;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusSelectAll() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusSelectAll?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTSendAlert(parms: BTSendAlertRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTSendAlert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolAlertSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "BusTracker/SchoolAlertSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusAlertSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusAlertSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivateBusAlerts(parms: BusAlertToggleRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/ActivateBusAlerts";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeactivateBusAlerts(parms: BusAlertToggleRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DeactivateBusAlerts";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceAlertSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceAlertSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivateGeoFenceAlerts(parms: GeoFenceAlertToggleRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/ActivateGeoFenceAlerts";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeactivateGeoFenceAlerts(parms: GeoFenceAlertToggleRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DeactivateGeoFenceAlerts";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerMapSoundsSelect() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerMapSoundsSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetImage(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/PersonGetImage?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusGetPersonPhotos(parms: BTBusGetPersonPhotosRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusGetPersonPhotos";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
